import { useState } from "react";

export function Hero() {
  const image = "https://games.jayveertech.com/event.png";

  return (
    <section
      className="relative overflow-hidden px-4 py-12 sm:py-16"
      style={{
        background:
          "linear-gradient(135deg, #12122a 0%, #161028 40%, #0d1a0d 100%)",
      }}
    >
      {/* Grid overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,200,100,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(0,200,100,0.06) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />

      {/* Purple glow — top left */}
      <div
        className="absolute -top-16 -left-16 w-64 h-64 sm:w-96 sm:h-96 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(100,40,220,0.45) 0%, transparent 70%)",
        }}
      />

      {/* Green glow — bottom right */}
      <div
        className="absolute -bottom-10 -right-10 w-56 h-56 sm:w-80 sm:h-80 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(0,220,80,0.3) 0%, transparent 70%)",
        }}
      />

      {/* Corner brackets */}
      <div
        className="absolute top-3 left-3 w-5 h-5 sm:w-7 sm:h-7 border-t-2 border-l-2"
        style={{ borderColor: "#39ff14" }}
      />
      <div
        className="absolute top-3 right-3 w-5 h-5 sm:w-7 sm:h-7 border-t-2 border-r-2"
        style={{ borderColor: "#8b5cf6" }}
      />
      <div
        className="absolute bottom-3 left-3 w-5 h-5 sm:w-7 sm:h-7 border-b-2 border-l-2"
        style={{ borderColor: "#8b5cf6" }}
      />
      <div
        className="absolute bottom-3 right-3 w-5 h-5 sm:w-7 sm:h-7 border-b-2 border-r-2"
        style={{ borderColor: "#39ff14" }}
      />

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        {/* LEFT — Content */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left w-full lg:w-1/2">
          {/* Eyebrow */}
          <p
            className="text-xs font-semibold uppercase mb-3"
            style={{
              color: "#39ff14",
              fontFamily: "'Rajdhani', sans-serif",
              letterSpacing: "4px",
            }}
          >
            Play · Compete · Conquer
          </p>

          {/* Title - SISTC */}
          <h1
            className="leading-none mb-2"
            style={{
              fontFamily: "'Bebas Neue', Impact, sans-serif",
              fontSize: "clamp(16px, 4vw, 33px)",
              letterSpacing: "4px",
            }}
          >
            <span
              style={{
                color: "#7c3aed",
                textShadow: "0 0 30px rgba(124,58,237,0.6)",
              }}
            >
              SIS
            </span>
            <span
              style={{
                color: "#39ff14",
                textShadow: "0 0 30px rgba(57,255,20,0.6)",
              }}
            >
              TC
            </span>
          </h1>

          {/* Org name */}
          <p
            className="font-semibold tracking-wide mb-1 px-2 lg:px-0"
            style={{
              color: "rgba(255,255,255,0.55)",
              fontFamily: "'Rajdhani', sans-serif",
              fontSize: "clamp(12px, 3.5vw, 15px)",
            }}
          >
            Sydney International School of Technology and Commerce
          </p>

          {/* Divider */}
          <div
            className="my-3 h-px w-32 sm:w-40"
            style={{
              background:
                "linear-gradient(90deg, transparent, #7c3aed, #39ff14, transparent)",
            }}
          />

          {/* Tagline */}
          <div
            className="rounded-full px-4 sm:px-6 py-2 font-semibold tracking-wide"
            style={{
              background: "rgba(139,92,246,0.15)",
              border: "1px solid rgba(139,92,246,0.4)",
              color: "rgba(255,255,255,0.9)",
              fontFamily: "'Rajdhani', sans-serif",
              fontSize: "clamp(13px, 3.5vw, 15px)",
            }}
          >
            Join us for <span style={{ color: "#39ff14" }}>Fun</span>,{" "}
            <span style={{ color: "#a78bfa" }}>Games</span>, and{" "}
            <span style={{ color: "#f59e0b" }}>Glory</span>!
          </div>

          {/* Date */}
          <div
            className="flex flex-wrap items-center justify-center lg:justify-start gap-2 sm:gap-3 mt-4 px-4 sm:px-5 py-2 rounded-lg"
            style={{
              background: "rgba(0,0,0,0.4)",
              border: "1px solid rgba(57,255,20,0.35)",
            }}
          >
            <span
              className="font-bold tracking-widest uppercase"
              style={{
                color: "#39ff14",
                fontFamily: "'Rajdhani', sans-serif",
                fontSize: "clamp(9px, 2.5vw, 11px)",
              }}
            >
              Save the date
            </span>
            <div
              className="hidden sm:block w-px h-6"
              style={{ background: "rgba(255,255,255,0.15)" }}
            />
            <span
              style={{
                fontFamily: "'Bebas Neue', Impact, sans-serif",
                fontSize: "clamp(16px, 5vw, 22px)",
                letterSpacing: "2px",
                color: "#fff",
              }}
            >
              Tuesday 21 April 2026
            </span>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start mt-5">
            <a
              href="#events"
              className="px-5 py-2 font-semibold text-[11px] sm:text-xs uppercase tracking-[0.2em]
    rounded-md text-white text-center
    bg-gradient-to-r from-purple-600 to-purple-800 shadow-lg hover:scale-105 transition"
            >
              Explore Events
            </a>

            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSfCwWKMBqosN0j1lIik75CAtlDIIWPzB2E7ata_H8MB6DWTzg/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 font-semibold text-[11px] sm:text-xs uppercase tracking-[0.2em]
    rounded-md text-center border border-green-400/60 text-green-300
    hover:bg-green-400/10 transition"
            >
              Register Now
            </a>

            <a
              href="https://games.jayveertech.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 font-semibold text-[11px] sm:text-xs uppercase tracking-[0.2em]
    rounded-md text-center
    bg-gradient-to-r from-green-400 to-green-600 text-black
    shadow-md hover:scale-105 transition"
            >
              Play Live Game
            </a>
          </div>

          <p
            className="mt-4 tracking-widest uppercase"
            style={{
              color: "rgba(255,255,255,0.3)",
              fontSize: "clamp(9px, 2.5vw, 11px)",
            }}
          >
            www.novafest.sistc.edu.au
          </p>
        </div>

        {/* RIGHT — Larger Image Container (now matching left side size) */}
        <div className="hidden lg:flex w-full lg:w-1/2 justify-center items-center relative">
          <div
            className="relative w-full max-w-[600px] overflow-hidden rounded-3xl border border-purple-500/30 shadow-2xl"
            style={{
              aspectRatio: "16 / 9",
              boxShadow: "0 30px 60px -15px rgba(124, 58, 237, 0.5)",
              width: "100%",
            }}
          >
            {/* Neon top accent */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "4px",
                background: "linear-gradient(90deg, #7c3aed, #39ff14, #a855f7)",
                zIndex: 2,
              }}
            />

            <img
              src={image}
              alt="NovaFest"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />

            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(124,58,237,0.15) 0%, transparent 50%)",
                pointerEvents: "none",
              }}
            />
          </div>

          {/* Background Glow - Enhanced for larger image */}
          <div
            style={{
              position: "absolute",
              inset: "-100px",
              background:
                "radial-gradient(ellipse, rgba(124,58,237,0.3) 0%, transparent 70%)",
              zIndex: -1,
            }}
          />
        </div>
      </div>
    </section>
  );
}
